var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nc-form-textarea",style:({height: _vm.height, width: _vm.width})},[_c('textarea',_vm._g(_vm._b({attrs:{"name":"textarea","maxlength":"100"},domProps:{"value":_vm.value}},'textarea',_vm.$attrs,false),_vm.inputListeners))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3588d260","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-cat/vc-textarea.vue
// module id = null
// module chunks = 